import { IMessage } from "@novu/notification-center";
import dayjs from "dayjs";

export function getTimeDiffTextFromDate(
  date?: dayjs.Dayjs,
  abbreviation = false,
  unit = 6,
  expiredAt?: dayjs.Dayjs
) {
  const currentDate = expiredAt ?? dayjs();
  const providedDate = expiredAt ? dayjs() : dayjs(date);

  const differenceInSeconds = currentDate.diff(providedDate, "second");
  const differenceInMinutes = currentDate.diff(providedDate, "minute");
  const differenceInHours = currentDate.diff(providedDate, "hour");
  const differenceInDays = currentDate.diff(providedDate, "day");
  const differenceInMonths = currentDate.diff(providedDate, "month");
  const differenceInYears = currentDate.diff(providedDate, "year");

  if (differenceInYears >= 1) {
    const monthsRemaining = differenceInMonths - differenceInYears * 12;
    return abbreviation
      ? `${differenceInYears} y ${monthsRemaining} mo`
      : `${differenceInYears} year${
          differenceInYears !== 1 ? "s" : ""
        } ${monthsRemaining} month${monthsRemaining !== 1 ? "s" : ""}`;
  }

  if (differenceInMonths >= 1) {
    const weeksRemaining = differenceInDays - differenceInMonths * 30;
    return abbreviation
      ? `${differenceInMonths} mo ${weeksRemaining} w`
      : `${differenceInMonths} month${
          differenceInMonths !== 1 ? "s" : ""
        } ${weeksRemaining} week${weeksRemaining !== 1 ? "s" : ""}`;
  }

  if (differenceInDays >= 1) {
    const hoursRemaining = differenceInHours - differenceInDays * 24;
    return abbreviation
      ? `${differenceInDays} d ${hoursRemaining} h`
      : `${differenceInDays} day${
          differenceInDays !== 1 ? "s" : ""
        } ${hoursRemaining} hour${hoursRemaining !== 1 ? "s" : ""}`;
  }

  if (differenceInHours >= 1) {
    const minutesRemaining = differenceInMinutes - differenceInHours * 60;
    return abbreviation
      ? `${differenceInHours} h ${minutesRemaining} m`
      : `${differenceInHours} hour${
          differenceInHours !== 1 ? "s" : ""
        } ${minutesRemaining} minute${minutesRemaining !== 1 ? "s" : ""}`;
  }

  const secondsRemaining = differenceInSeconds - differenceInMinutes * 60;
  return abbreviation
    ? `${
        differenceInMinutes > 0 ? "" : differenceInMinutes
      } m ${secondsRemaining} s`
    : `${differenceInMinutes > 0 ? differenceInMinutes + " minutes" : ""} ${
        differenceInMinutes !== 1 ? "" : ""
      } ${secondsRemaining} second${secondsRemaining !== 1 ? "s" : ""}`;
}

export function getTimeDiffTextFromDate2(date: string) {
  const currentDate = dayjs();
  const providedDate = dayjs(date);

  const differenceInSeconds = currentDate.diff(providedDate, "second");

  if (differenceInSeconds < 60) {
    return `${differenceInSeconds} second${
      differenceInSeconds !== 1 ? "s" : ""
    } ago`;
  }

  const differenceInMinutes = currentDate.diff(providedDate, "minute");

  if (differenceInMinutes < 60) {
    return `${differenceInMinutes} minute${
      differenceInMinutes !== 1 ? "s" : ""
    } ago`;
  }

  const differenceInHours = currentDate.diff(providedDate, "hour");

  if (differenceInHours < 24) {
    return `${differenceInHours} hour${differenceInHours !== 1 ? "s" : ""} ago`;
  }

  const differenceInDays = currentDate.diff(providedDate, "day");

  if (differenceInDays < 30) {
    return `${differenceInDays} day${differenceInDays !== 1 ? "s" : ""} ago`;
  }

  const differenceInMonths = currentDate.diff(providedDate, "month");

  if (differenceInMonths < 12) {
    return `${differenceInMonths} month${
      differenceInMonths !== 1 ? "s" : ""
    } ago`;
  }

  const differenceInYears = currentDate.diff(providedDate, "year");

  return `${differenceInYears} year${differenceInYears !== 1 ? "s" : ""} ago`;
}

export function checkExpiry(message: IMessage): boolean {
  const bufferTime = message?.payload?.bufferTime as unknown as number;
  if (!bufferTime) return false;
  const expiredAt = dayjs(message.createdAt).add(bufferTime, "minute");
  const diff = expiredAt.diff(dayjs(), "second");
  return Boolean(diff < 0);
}
